import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../PrimaryButton";
import { TabBarContainer } from "./styles";
import iconScenario from "../../assets/icons/scenario.svg";
import iconHome from "../../assets/icons/home.svg";
import iconGlossary from "../../assets/icons/glossary.svg";
import iconAccesibility from "../../assets/icons/accessibility.svg";
import inconAtendimento from "../../assets/icons/atendimento.svg"

interface TabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  setAcessibility: (bool: boolean) => void
}

export function TabBar({ activeTab, setActiveTab, setAcessibility }: TabBarProps) {
  const navigate = useNavigate();
  const tabs = [
    { key: "home", icon: iconHome, alt: "Início", label: "Início" },
    { key: "scenario", icon: iconScenario, alt: "Cenários", label: "Central de Conteúdos" },
    { key: "glossary", icon: iconGlossary, alt: "Glossário", label: "Glossário" },
    { key: "attendance", icon: inconAtendimento, alt: "Atendimento", label: "Atendimento" },
    { key: "acessibility", icon: iconAccesibility, alt: "Acessibilidade", label: "Acessibilidade" },
  ];

  return (
    <TabBarContainer className="tabs">
      {tabs.map((tab) => (
        <PrimaryButton
          key={tab.key}
          className={`button hint ${activeTab === tab.key ? "active" : ""}`}
          data-hint={tab.label}
          data-hint-placement="top"
          onClick={() => {
            if (tab.key === "acessibility") {
              setAcessibility(true)
            } else {
              setActiveTab(tab.key);
            }
          }}
        >
          <img src={tab.icon} alt={tab.alt} />
        </PrimaryButton>
      ))}
    </TabBarContainer>
  );
}